import {
  Box,
  Chip
} from '@mui/material';
import { StyledTextChip } from 'modules';



export type ChipsProps = {};

export const Chips = (props: ChipsProps) => {

  return (
    <Box display='flex' flexDirection='row' gap='1rem' padding='.2rem'>
      <StyledTextChip.FC
        upIsGood
        label='3.6% month'
        type='STAT_INCREASE'
      />
      <StyledTextChip.FC
        upIsGood
        label='3.6% month'
        type='STAT_DECREASE'
      />

      <StyledTextChip.FC
        upIsGood={false}
        label='3.6% month'
        type='STAT_INCREASE'
      />
      <StyledTextChip.FC
        upIsGood={false}
        label='3.6% month'
        type='STAT_DECREASE'
      />
      <Chip
        variant='custom'
        label='test'
      />
    </Box>
  );
};
